import "#legacy/shared/sparkle_namespace.js";
import "./page_builder/dragulish.js";
import "#legacy/utilities/iframe_ready_detection.js";
import "#legacy/shared/sparkle_backbone.js";
import "#vendor/dragula.js";
import "#vendor/spectrum.js";
import "#vendor/cropper.js";
import "#vendor/serializejson.jquery.js";
import "#legacy/handlebars_helpers/index.js";
import "./page_builder/persistence.js";
import { disableFormBuilderInputs } from "#/shared/legacy/forms/form-preview.js";
import "./page_builder/init.js";
import { createInPlaceSave } from "#/admin/page_builder/in-place-save";
import "./singleton/form_builder/index.js";
import.meta.glob("#legacy/form_builder/templates/**/*.{js,hbs,jst.ejs}", { eager: true });

// VITE_MIGRATION: register every page-builder Handlebars template on
// `window.Sparkle.HandlebarsTemplates` so `findTemplate(...)` lookups
// resolve. Under Sprockets the `handlebars_assets` gem auto-precompiled
// every .hbs in the asset path, but under Vite each file is registered
// only when imported. Without this glob, tools like `behavior.tool.js`
// (templateId "behavior-editor-template") throw "No matching template
// found for template name: behavior-editor-template" on every admin
// page that boots the page-builder bundle.
import.meta.glob("./page_builder/templates/**/*.hbs", { eager: true });

jQuery(function () {
  var PageBuilder = Sparkle.PageBuilder,
    Sidebar = PageBuilder.Sidebar,
    Layout = PageBuilder.Layout,
    Component = PageBuilder.Component,
    Section = PageBuilder.Section,
    Drag = Sparkle.PageBuilder.Drag,
    initialize = PageBuilder.initialize,
    reinitialize = PageBuilder.reinitialize,
    deepCopy = Sparkle.PageBuilder.Helpers.deepCopy,
    initialized = false,
    toolsLoading = false,
    sidebar,
    drag = false,
    loadingIndicator = jQuery(Sparkle.spinner),
    inPlaceSave;

  var PREVIEW_SCROLL_HOLD_DURATION = 3000; // milliseconds

  // Hiding the Content tab resets the preview window's scroll position to 0, so the position
  // is remembered from the preview's own scroll events and restored when the tab shows again.
  var previewScrollTop = 0;
  var previewHidden = false;

  showLoadingIndicator();

  if (jQuery("#page-preview").length) {
    inPlaceSave = createPageInPlaceSave();
    Sparkle.Utilities.onIframeLoad(jQuery("#page-preview"), whenPreviewContentReady);
    new ResizeObserver(restorePreviewScrollTopWhenShown).observe(document.getElementById("page-preview"));
  }

  // Created before the preview loads, so that the save hears the editor's first interaction.
  function createPageInPlaceSave() {
    var form = document.querySelector("[data-behaviour~=primary-form]");

    return createInPlaceSave({ form: form, output: form.querySelector("[data-behaviour~=page-builder-output]") });
  }

  // The iframe reports a height of 0 while the Content tab is hidden.
  function restorePreviewScrollTopWhenShown(entries) {
    var hidden = entries[0].contentRect.height === 0;

    if (previewHidden && !hidden) {
      document.getElementById("page-preview").contentWindow.scrollTo(0, previewScrollTop);
    }
    previewHidden = hidden;
  }

  // A preview embedded in a host page (`defer_inject` in publishing_domains.yml) receives its Sparkle content
  // only after the host page loads, so the component sections do not exist yet when the iframe reports ready.
  function whenPreviewContentReady() {
    var previewWindow = document.getElementById("page-preview").contentWindow;

    if (previewWindow.SPARKLE_EMBED_CONTENT_PENDING) {
      previewWindow.document.addEventListener("sparkle:embed-content-injected", iframeLoaded, { once: true });
    } else {
      iframeLoaded();
    }
  }

  function iframeLoaded() {
    if (drag) {
      drag.destroy();
    }
    var previewElement = document.getElementById("page-preview"),
      $previewWrapper = jQuery("#page_builder_container"),
      previewWindow = previewElement.contentWindow,
      sideElement = document.getElementById("page-edit-pane"),
      previewDocument = previewWindow.document,
      previewBody = previewDocument.body;

    try {
      assertPreviewingCorrectResource(previewElement.src, previewWindow.PAGE_BUILDER_REQUEST_URL);
    } catch (e) {
      ClientExceptionNotifier.notify(e, null, {
        canDescribe: false,
        text: "Page builder is unable to initialize because the expected page did not load.",
        throwException: false,
      });
    }
    jQuery(previewBody).prepend(jQuery("body > svg:first-of-type").clone());
    var currentResourceColor = jQuery(previewElement).data("current-resource-color");

    if (currentResourceColor) {
      var backgroundCss = { "background-color": currentResourceColor };
    } else {
      var backgroundCss = { background: "#f0f0f0" };
    }
    jQuery(previewDocument).find("html").css(backgroundCss);
    hideLoadingIndicator();

    try {
      if (!initialized) {
        sidebar = initialize(
          previewWindow.PAGE_BUILDER_COMPONENT_JSON,
          window.CALL_TRACKING_DATA,
          window.COMPONENTS,
          previewDocument.body,
          sideElement,
        );
      } else {
        reinitialize(previewWindow.PAGE_BUILDER_COMPONENT_JSON, window.COMPONENTS, previewDocument.body, sidebar);
      }
      drag = Drag(sidebar);
    } catch (e) {
      console.error(e);
      ClientExceptionNotifier.notify(e);
      return;
    }
    hideLoadingIndicator();
    sidebar.showDefaultView();

    // disable links.
    jQuery(previewBody).on("click", function (e) {
      var $target = jQuery(e.target);
      if ($target.is("a") || $target.parent().is("a")) {
        e.preventDefault();
      }
    });

    // prevent any clicks on a form
    disableFormBuilderInputs(previewBody);

    // Handle selection and deselection of elements
    jQuery(previewDocument).on("mousedown", function (event) {
      var clickedResizer = jQuery(event.target).closest(".resizer").length;
      var componentElement = jQuery(event.target).closest(".component").get(0);
      var clickedCurrentComponent = sidebar.isEditingComponent(componentElement);
      // Ignore clicks under these conditions
      if (clickedCurrentComponent || clickedResizer) {
        return;
      }
      // If the click was on a component, edit it
      if (componentElement) {
        sidebar.save();
        sidebar.editComponent(componentElement);
      } else {
        sidebar.done();
      }
    });

    Component.each(function (component) {
      component.renderActionBar();
    });

    /**
     * SOFT RELOAD BEHAVIOR
     *  The below code acts as a way to reload the current preview in various
     *   conditions without causing a redirect or other unwanted behavior. When
     *   certain conditions occur (such as a page settings change)
     *   we need to refresh the preview panel.
     */

    // element selectors
    var selectors = {
      frame: "#page-preview",
      output: "[data-behaviour~=page-builder-output]",
      form: "[data-behaviour~=primary-form]",
      preview: '[data-behaviour~=primary-form] [data-reload-preview="true"]',
      layoutSelector: "select#page_layout_name",
    };

    // general variables
    var $document = jQuery(document),
      $form = jQuery(selectors.form),
      $frame = jQuery(selectors.frame),
      $frameBody = jQuery(previewBody);

    function queueReloadPreviewChange() {
      if (jQuery("#tab_page_builder").data("reload-required")) {
        return;
      }

      jQuery("#tab_page_builder")
        .data("reload-required", true)
        .one("change", function () {
          jQuery("#tab_page_builder").data("reload-required", false);
          triggerReloadPreviewChange();
        });
    }

    /**
     * @name triggerReloadPreviewChange
     * @description
     *   Submit the original page form with the page-preview iframe as the target,
     *   This will allow us to trigger a soft refresh without
     *   throwing anything else on the page out of sync.
     */
    function triggerReloadPreviewChange() {
      var previewUrl = new URL($form.find("[name=preview_url]").val(), window.location.origin);
      $document.off("change", queueReloadPreviewChange);
      $document.off("submit", updateOutputFormValue);

      drag.destroy();
      showLoadingIndicator();

      window.localStorage.setItem("preview-frame-scrolltop", previewScrollTop);

      // Make sure latest PB JSON is serialized to the output field.
      updateOutputFormValue();

      $form.attr("target", "page-preview");
      $form.append('<input type="hidden" name="dry_run" value="true">');
      $form.append('<input type="hidden" name="page_builder" value="true">');
      // We use the Rehearsal gem to generate a modified content preview for unsaved changes.
      // The preview_url param ensures Rehearsal uses the same url for the pagebuilder content preview
      // see https://github.com/combinaut/rehearsal/blob/master/lib/rehearsal/middleware.rb#L52
      previewUrl.searchParams.set("page_builder", true);
      $form.find("[name=preview_url]").val(previewUrl);
      // A real submit event, so listeners bound with addEventListener hear it —
      // jQuery's trigger("submit") reaches only jQuery-bound handlers.
      if ($form[0].dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }))) {
        $form[0].submit();
      }
      $form.removeAttr("target");
      $form.find("[name=dry_run]").remove();
      $form.find("[name=page_builder]").remove();
    }

    // add listeners to form
    $document.on("change", selectors.preview, queueReloadPreviewChange);
    $document.on("submit", selectors.form, updateOutputFormValue);

    if (!initialized) {
      initialized = true;
      inPlaceSave.saveOnSubmit(updateOutputFormValue);
    }

    /**
     * @name updateOutputFormValue
     * @description
     *  This is a quick helper to make sure that the page content gets submitted
     *   along with the form in its current state. Without this, the soft reload
     *   really does nothing, and wont ever temporarily persist data.
     */
    function updateOutputFormValue() {
      $form.find(selectors.output).val(PageBuilder.Page.toJson());
    }

    function markAsDirty() {
      // changes initiated by tools loading, like setting default
      // values, etc. are ignored. Only care about user initiated changes
      if (!toolsLoading) {
        updateOutputFormValue();
        $form.find(selectors.output).trigger("change"); // Fire change for dirty tracking
      }
    }

    // attach event behavior
    PageBuilder.Page.saveAndReload = function () {
      updateOutputFormValue();
      triggerReloadPreviewChange();
    };
    PageBuilder.Helpers.Event.on("pb:component:save", markAsDirty);
    PageBuilder.Helpers.Event.on("pb:section:remove", markAsDirty);
    PageBuilder.Helpers.Event.on("pb:section:remove", function () {
      sidebar.page.unload();
    });
    PageBuilder.Helpers.Event.on("pb:tools:load:start", function () {
      toolsLoading = true;
    });
    PageBuilder.Helpers.Event.on("pb:tools:load:done", function () {
      toolsLoading = false;
    });

    function rememberPreviewScrollTop() {
      if (previewElement.getClientRects().length > 0) {
        previewScrollTop = previewWindow.scrollY;
      }
    }

    previewWindow.addEventListener("scroll", rememberPreviewScrollTop, { passive: true });

    var storedScrollTop = parseInt(window.localStorage.getItem("preview-frame-scrolltop"));
    if (isNaN(storedScrollTop)) {
      previewScrollTop = 0;
    } else {
      window.localStorage.removeItem("preview-frame-scrolltop");
      // Seeded for the restore on show, in case the reload lands while the Content tab is hidden.
      previewScrollTop = storedScrollTop;
      holdPreviewScrollTop(previewWindow, storedScrollTop);
    }

    jQuery(previewElement).trigger("pagebuilder:ready");
  } // end load event handler

  PageBuilder.Helpers.Event.on("pb:component:refresh-rendered-content", refreshEditedComponent);
  PageBuilder.Helpers.Event.on("pb:component:save", refreshUnrenderedComponent);

  function refreshEditedComponent() {
    // Tools write their defaults while they load, which is not an edit.
    if (toolsLoading || !sidebar.page.component) {
      return;
    }

    refreshRenderedContent(sidebar.page.component);
  }

  // A component added since the last save was never rendered by the server, so its first edit
  // asks for the content. Deferred, because an edit to a refreshing attribute requests the
  // content right after its save, and that request stands in for this one.
  function refreshUnrenderedComponent() {
    var component = sidebar && sidebar.page.component;
    if (toolsLoading || !component || !refreshesRenderedContent(component)) {
      return;
    }

    setTimeout(function () {
      var rendered = component.rendered.context;
      var missing = Component.serverRenderedAttributes(component).some(function (attribute) {
        return !(attribute in rendered);
      });
      if (missing && !component.renderedContentRequest) {
        refreshRenderedContent(component);
      }
    });
  }

  function refreshesRenderedContent(component) {
    return _.some(component.config.attributes, function (attribute) {
      return attribute && attribute.refresh_rendered_content;
    });
  }

  // Returns the uuid the server resolves the edited record from. The server assigns one on
  // save, so a component added since then gets the one it will be given.
  function componentUuid(component) {
    if (component.rendered.context.uuid) {
      return component.rendered.context.uuid;
    }
    if (!(window.RESOURCE && window.RESOURCE.baseType && window.RESOURCE.id)) {
      return null;
    }

    return [window.RESOURCE.baseType, window.RESOURCE.id, component.key].join("-");
  }

  // Refreshes the server-rendered attributes of the component and of everything that renders
  // together with it. Each one is rendered from its own unsaved context, because the instances of
  // a shared component can carry different overrides.
  function refreshRenderedContent(component) {
    instancesRenderedWith(component).forEach(refreshInstance);
  }

  // Fetches the instance's server-rendered attributes for its unsaved context and re-renders it.
  // The latest request wins when several are in flight, and a failed one leaves the instance
  // free to ask again.
  function refreshInstance(instance) {
    var uuid = componentUuid(instance);
    if (!uuid) {
      return;
    }

    var serverRenderedAttributes = Component.serverRenderedAttributes(instance);
    var context = jQuery.extend({}, instance.rendered.context, instance.context, { uuid: uuid });
    serverRenderedAttributes.forEach(function (attribute) {
      context[attribute] = instance.context[attribute];
    });

    var request = (instance.renderedContentRequest = PageBuilder.Persistence.putJSON(
      "/admin/components/render_from_data.json",
      { page_builder: true, data: { template: instance.config.id, context: context } },
    ));

    request
      .done(function (renderedContext) {
        if (instance.renderedContentRequest !== request) {
          return;
        }

        serverRenderedAttributes.forEach(function (attribute) {
          instance.rendered.context[attribute] = renderedContext[attribute];
        });
        instance.render();
      })
      .fail(function () {
        if (instance.renderedContentRequest === request) {
          instance.renderedContentRequest = null;
        }
      });
  }

  // Returns the components that render together with `component`. Rendering a shared component
  // also renders its other instances on the page, each from its own server-rendered content.
  function instancesRenderedWith(component) {
    if (!component.shared) {
      return [component];
    }

    var instances = [];
    Component.each(function (other) {
      if (other.shared && other.id === component.id) {
        instances.push(other);
      }
    });
    return instances;
  }

  function showLoadingIndicator() {
    jQuery("#page_builder_container").append(loadingIndicator).addClass("page-builder-loading");
  }

  function hideLoadingIndicator() {
    loadingIndicator.remove();
    jQuery("#page_builder_container").removeClass("page-builder-loading");
  }

  // Scrolls the preview to `scrollTop` and re-applies it whenever the preview's height changes,
  // because custom elements render after the iframe's load event and move the content below them.
  // Stops once the editor interacts with the preview, or after `PREVIEW_SCROLL_HOLD_DURATION`.
  function holdPreviewScrollTop(previewWindow, scrollTop) {
    var observer = new previewWindow.ResizeObserver(restore);

    function restore() {
      previewWindow.scrollTo(0, scrollTop);
    }

    function release() {
      observer.disconnect();
    }

    restore();
    observer.observe(previewWindow.document.body);
    ["wheel", "touchstart", "keydown", "mousedown"].forEach(function (eventName) {
      previewWindow.addEventListener(eventName, release, { once: true, passive: true });
    });
    window.setTimeout(release, PREVIEW_SCROLL_HOLD_DURATION);
  }

  function assertPreviewingCorrectResource(expected, actual) {
    if (!actual) {
      throw new IncorrectPreviewResourceException("Preview page did not load");
    }

    var expectedURI = new URL(expected);
    var actualURI = new URL(actual);
    var expectedSearch = expectedURI.searchParams;
    var actualSearch = actualURI.searchParams;

    // Compare the path, and the expected parts of the query.
    // Avoids failing when navigating back to the page after some js updates the iframe's internal url.
    // See https://github.com/combinaut/sparkle/issues/5521#issuecomment-410469872
    var mismatch = expectedURI.pathname != actualURI.pathname;
    jQuery.each(expectedSearch.keys, function (key) {
      mismatch = mismatch || actualSearch.get(key) != expectedSearch.get(key);
    });

    if (mismatch) {
      throw new IncorrectPreviewResourceException(
        "Expected page builder to use " + expected + ", but preview was of " + actual,
      );
    }
  }

  // EXCEPTIONS
  function IncorrectPreviewResourceException(message) {
    this.message = message;
  }
});
